import {
    ApiParameter,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";

const requestAccountsUrl = "/api/sainc/myAccount/requestAccount";

export interface RequestAccountModel {
    email: string;
    firstName: string;
    lastName: string;
    companyName: string;
    customerNumber?: string;
    phone?: string;
    country: string;
    address1?: string;
    address2?: string;
    city: string;
    state: string;
    postalCode?: string;
    role: string;
    isTaxExempt?: boolean;
    applyForCredit?: boolean;
    signUpForNewsLetter?: boolean;
    dataShareOptOut?: boolean;
}

export interface RequestAccountApiParameter extends ApiParameter {
    account: Partial<RequestAccountModel>;
}

export async function requestAccount(parameter: RequestAccountApiParameter): Promise<ServiceResult<RequestAccountModel>> {
    try {
        const requestAccountModel = await post<RequestAccountModel>(`${requestAccountsUrl}`, parameter.account as RequestAccountModel);
        return {
            result: requestAccountModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: ((error as any)?.errorJson?.message),
        };
    }
}